import React, { useState } from 'react';
import Sidebar from './../components/sidebar';
import { Container, Row, Col, Card, Form, Button, Alert, Badge } from 'react-bootstrap';
import { FaUserGraduate, FaEnvelope, FaLink, FaUsers, FaGift, FaCheckCircle } from 'react-icons/fa';

const Invitaalaacademia = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    invitadoNombre: '',
    invitadoEmail: '',
    cursoInteres: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [copied, setCopied] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState('formulario');

  // Cursos disponibles
  const cursos = [
    'CIRP Básico',
    'CIRP Avanzado',
    'Certificación Internacional',
    'Taller Práctico',
    'Programa Ejecutivo'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Datos enviados:', formData);
    setSubmitted(true);
  };

  const copyInvitationLink = () => {
    const link = `https://mrcirp.com/invite?ref=${formData.nombre.replace(/\s+/g, '-').toLowerCase()}`;
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <Sidebar>
      <Container className="mt-4 mb-5">
        <Row className="mb-4 text-center">
          <Col>
            <h1 className="text-primary">
              <FaUserGraduate className="me-2" />
              Invita a la Academia MrCIRP
            </h1>
            <p className="lead">
              Comparte el conocimiento y gana beneficios exclusivos
            </p>
            <Badge bg="success" className="mb-3">
              Programa de Referidos Activo
            </Badge>
          </Col>
        </Row>

        {submitted ? (
          <Row className="justify-content-center">
            <Col md={8}>
              <Alert variant="success" className="text-center">
                <FaCheckCircle size={24} className="me-2" />
                <h4>¡Invitación enviada con éxito!</h4>
                <p>
                  Hemos enviado los detalles a {formData.invitadoNombre}. 
                  <br />
                  Cuando se registre, ambos recibirán sus beneficios.
                </p>
                <Button 
                  variant="outline-success" 
                  onClick={() => setSubmitted(false)}
                >
                  Enviar otra invitación
                </Button>
              </Alert>
            </Col>
          </Row>
        ) : (
          <>
            <Row className="mb-4">
              <Col>
                <div className="d-flex justify-content-center">
                  <Button
                    variant={selectedMethod === 'formulario' ? 'primary' : 'outline-primary'}
                    className="me-3"
                    onClick={() => setSelectedMethod('formulario')}
                  >
                    <FaEnvelope className="me-2" />
                    Invitación personalizada
                  </Button>
                  <Button
                    variant={selectedMethod === 'enlace' ? 'primary' : 'outline-primary'}
                    onClick={() => setSelectedMethod('enlace')}
                  >
                    <FaLink className="me-2" />
                    Compartir enlace
                  </Button>
                </div>
              </Col>
            </Row>

            {selectedMethod === 'formulario' ? (
              <Row>
                <Col lg={6} className="mb-4">
                  <Card className="shadow-sm h-100">
                    <Card.Body>
                      <Card.Title className="mb-4 border-bottom pb-3">
                        Formulario de Invitación
                      </Card.Title>
                      
                      <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                          <Form.Label>Tu nombre completo</Form.Label>
                          <Form.Control
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Tu email registrado</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Nombre del invitado</Form.Label>
                          <Form.Control
                            type="text"
                            name="invitadoNombre"
                            value={formData.invitadoNombre}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Email del invitado</Form.Label>
                          <Form.Control
                            type="email"
                            name="invitadoEmail"
                            value={formData.invitadoEmail}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>

                        <Form.Group className="mb-4">
                          <Form.Label>Curso de interés</Form.Label>
                          <Form.Select
                            name="cursoInteres"
                            value={formData.cursoInteres}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Selecciona un curso</option>
                            {cursos.map((curso, index) => (
                              <option key={index} value={curso}>{curso}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>

                        <Button variant="primary" type="submit" className="w-100 py-2">
                          Enviar Invitación
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>

                <Col lg={6}>
                  <Card className="shadow-sm h-100">
                    <Card.Body>
                      <Card.Title className="mb-4 border-bottom pb-3">
                        <FaGift className="me-2 text-warning" />
                        Beneficios por Invitar
                      </Card.Title>

                      <div className="mb-4">
                        <h5><FaUsers className="me-2 text-primary" /> Para ti:</h5>
                        <ul className="list-unstyled">
                          <li className="mb-2">
                            <FaCheckCircle className="text-success me-2" />
                            10% de descuento en tu próxima certificación
                          </li>
                          <li className="mb-2">
                            <FaCheckCircle className="text-success me-2" />
                            Acceso a material exclusivo
                          </li>
                          <li>
                            <FaCheckCircle className="text-success me-2" />
                            Puntos canjeables por cursos
                          </li>
                        </ul>
                      </div>

                      <div>
                        <h5><FaUserGraduate className="me-2 text-primary" /> Para tu invitado:</h5>
                        <ul className="list-unstyled">
                          <li className="mb-2">
                            <FaCheckCircle className="text-success me-2" />
                            15% de descuento en su primera inscripción
                          </li>
                          <li className="mb-2">
                            <FaCheckCircle className="text-success me-2" />
                            Sesión de orientación gratuita
                          </li>
                          <li>
                            <FaCheckCircle className="text-success me-2" />
                            Kit de bienvenida MrCIRP
                          </li>
                        </ul>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ) : (
              <Row className="justify-content-center">
                <Col md={8}>
                  <Card className="shadow-sm">
                    <Card.Body className="text-center">
                      <FaLink size={48} className="text-primary mb-4" />
                      <h3>Comparte tu enlace personalizado</h3>
                      <p className="text-muted mb-4">
                        Copia y comparte este enlace directamente con tus contactos
                      </p>

                      <div className="input-group mb-3">
                        <Form.Control
                          type="text"
                          value={`https://mrcirp.com/invite?ref=${formData.nombre || 'usuario'}`}
                          readOnly
                        />
                        <Button 
                          variant={copied ? "success" : "primary"}
                          onClick={copyInvitationLink}
                        >
                          {copied ? "¡Copiado!" : "Copiar Enlace"}
                        </Button>
                      </div>

                      <div className="d-flex justify-content-center mt-3">
                        <Button variant="outline-primary" className="me-2">
                          Compartir por WhatsApp
                        </Button>
                        <Button variant="outline-primary">
                          Compartir por Email
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}
          </>
        )}

        <Row className="mt-4">
          <Col>
            <Card className="bg-light">
              <Card.Body className="p-3">
                <p className="small text-muted mb-0">
                  * Los beneficios se activan cuando tu invitado completa su inscripción y pago.
                  Válido para nuevos estudiantes. Máximo 5 invitaciones con beneficios por mes.
                  Consulta los <a href="https://mrcirp.com/terminos" className="text-decoration-none">términos completos</a>.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Sidebar>
  );
};

export default Invitaalaacademia;